import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Route, Router, UrlTree } from '@angular/router';
import { SideBarService } from '@shared/UI/elements-ui/sidebar/sidebar.service';
import { SessionService } from '@utils/services/session.service';
import { Observable, of } from 'rxjs';
import { NotificationService, NotificationSeverity } from '../services/notification.service';

@Injectable({
  providedIn: 'root'
})
export class UserGuard {

  constructor(
    private _router: Router,
    private _notifications: NotificationService,
    private _sidebarService: SideBarService,
    private _sessionService: SessionService
  ) {
  }

  canActivate(
    route: ActivatedRouteSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this._sessionService.user === null) {
      this._router.navigateByUrl('/auth/user');
      return of(false);
    }

    if (this._sessionService.user.type === 'admin') {
      if (route.data['restrictAdmin']) {
        this._notifications.create({
          severity: NotificationSeverity.warn,
          summary: 'No tienes permiso para acceder a esta página',
        });
        this._router.navigateByUrl('/priv/acuerdos-pago');
        return of(false);
      }
      return of(true);
    }

    const ModulePermissions = this._sessionService.user.permissions?.find(
      (permission) => permission.module === route.data['module'],
    );

    if (!ModulePermissions?.permissions.includes('view')) {
      this._router.navigate(['/priv/home']);
      this._sidebarService.clearOptions();
      this._notifications.create({
        severity: NotificationSeverity.warn,
        summary: 'No tienes permiso para acceder a esta página'
      });
      return false;
    }

    if (!route.data['permissions'] || route.data['permissions'].length === 0) {
      return of(true);
    }

    let hasPermissions = false;

    route.data['permissions'].forEach((permission: string) => {
      if (ModulePermissions.permissions.includes(permission)) {
        hasPermissions = true;
      }
    });

    if (!hasPermissions) {
      this._notifications.create({
        severity: NotificationSeverity.warn,
        summary: 'No tienes permiso para acceder a esta página'
      });
      this._sidebarService.clearOptions();
      this._router.navigateByUrl('/priv');
      return of(false);
    }

    return of(true);
  }

  canLoad(
    route: Route
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this._sessionService.user === null) {
      this._router.navigateByUrl('/auth/user');
      return of(false);
    }

    let isValidUser = this._sessionService.user.type === 'admin';
    if (isValidUser) {
      return of(true);
    }
    isValidUser = this._sessionService.user.type === 'user';
    if (!isValidUser) {
      this._notifications.create({
        severity: NotificationSeverity.warn,
        summary: 'No tienes permiso para acceder a esta página'
      });
      this._router.navigateByUrl('/priv');
    }

    const ModulePermissions = this._sessionService.user.permissions?.find(
      (permission) => permission.module === route.data?.['module'],
    );

    if (!ModulePermissions?.permissions.includes('view')) {
      this._router.navigate(['/priv/home']);
      this._notifications.create({
        severity: NotificationSeverity.warn,
        summary: 'No tienes permiso para acceder a esta página'
      });
      return false;
    }
    return of(isValidUser);
  }
}
